import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Content.module.scss';

/**
 * Card Content Component
 * @param {object} props
 * @param {object} props.ref - React ref object
 * @param {object} props.children - Child components
 * @param {string} props.className - Additional class name
 * @param {object} props.otherProps - Additional props
 */
export const Content = React.forwardRef((props, ref) => {
    const { children, className, ...otherProps } = props;

    return (
        <div ref={ref} className={classnames(styles['content'], className)} {...otherProps}>
            {children}
        </div>
    );
});

Content.displayName = 'Content';

Content.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default Content;
